import {
  LISTAR_CHAMADAS,
  LISTAR_CENTRO_DE_CUSTOS,
  LISTAR_CONFERENCIAS,
  LISTAR_TAGS,
  GERAR_DADOS_RELATORIO,
} from './mutation-types'

export default {
  [LISTAR_CHAMADAS]: (state, chamadas) => {
    state.chamadas = chamadas
  },
  [LISTAR_CENTRO_DE_CUSTOS]: (state, centroDeCustos) => {
    state.centroDeCustos = centroDeCustos
  },
  [LISTAR_CONFERENCIAS]: (state, conferencias) => {
    state.conferencias = conferencias
  },
  [LISTAR_TAGS]: (state, tags) => {
    state.tags = tags
  },
  [GERAR_DADOS_RELATORIO]: (state, dadosRelatorio) => {
    state.dadosRelatorio = dadosRelatorio
  },
}
